import { DecimalPipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { AccessByDevice } from '@app/requests/model/logalty-signature-model';

@Injectable({
  providedIn: 'root',
})
export class DetectDeviceService {
  constructor() {}

  public isAccessByDevice(): AccessByDevice {
    const device: AccessByDevice = {
      os: '',
      version: undefined,
    };
    const userAgent = window.navigator.userAgent;
    //Regex taken from the actual web isMobile.js
    if (
      /Android|webOS|BlackBerry|IEMobile|Opera Mini|\bAndroid(?:.+)Mobile\b|(?:SD4930UR|\bSilk(?:.+)Mobile\b)|Silk|Windows Phone|\bWindows(?:.+)ARM\b|BB10|\b(CriOS|Chrome)(?:.+)Mobile|Mobile(?:.+)Firefox\b/i.test(
        userAgent
      )
    ) {
      device.os = 'Android';
      device.version = this.androidVersion();
    } else if (/iP(hone|od|ad)/i.test(userAgent)) {
      device.os = 'iOS';
      device.version = this.iosVersion();
    }
    return device.os && device.version ? device : null;
  }

  private androidVersion() {
    let ua = window.navigator.userAgent.toLowerCase();
    let match = ua.match(/android\s([0-9\.]*)/i);
    const versionDevice = +match[1]?.substring(0, 3);
    return !isNaN(versionDevice) ? versionDevice : null;
  }

  private iosVersion() {
    let ua = window.navigator.userAgent.toLowerCase();
    const version = ua.match(/os (\d+)_(\d+)_?(\d+)?/);
    if (version) {
      const majorVersion = version[1];
      const minorVersion = version[2];
      const versionDevice = +(
        (!isNaN(+majorVersion) ? majorVersion : '0') +
        '.' +
        (!isNaN(+minorVersion) ? minorVersion : '0')
      );
      return !isNaN(versionDevice) ? versionDevice : null;
    }
  }
}
